// src/App.tsx
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { init } from "./slices/fleetSlice";
import { RootState } from "./store";
import { loadData } from "./data";
import { useSimClock } from "./useSimClock";
import Controls from "./components/Controls";
import WorldMap from "./components/WorldMap";
import closeIcon from "./assets/close.png";
import "./App.css";
import FleetSummary from "./components/FleetSummary";
import TimeBar from "./components/TimeBar";
import TripOverview from "./components/TripOverview";
import bellIcon from "./assets/danger.png";
import AlertsPanel from "./components/AlertsPanel";

export default function App() {
  const dispatch = useDispatch();
  const fleet = useSelector((s: RootState) => s.fleet);
  const [ready, setReady] = useState(false);
  const [term, setTerm] = useState("");
   const [showAlerts, setShowAlerts] = useState(false);
   const [selectedTrip, setSelectedTrip] = useState<string | undefined>(undefined);


  useSimClock();

  useEffect(() => {
    loadData().then((d) => {
      dispatch(init(d));
      setReady(true);
    });
  }, [dispatch]);

// live best match (case-insensitive substring)
const highlightId = useMemo(() => {
  if (!term.trim()) return undefined;
  const lower = term.toLowerCase();
  const entries = Object.entries(fleet.trips || {});

  // match either tripId or vehicleId
  const match = entries.find(([id, t]) =>
    id.toLowerCase().includes(lower) ||
    (t.vehicleId && t.vehicleId.toLowerCase().includes(lower))
  );
 

  return match ? match[0] : undefined;
}, [term, fleet.trips]);


  if (!ready) return <div style={{ padding: 16 }}>Loading…</div>;

  return (
    <div className="font-sans flex flex-col min-h-screen m-4 gap-4">
      
      <header className="z-[99] sticky top-4 rounded-[16px] flex justify-between items-center bg-[#171f54] p-3">
    <h1 className="m-0 pl-3 text-white">Fleet Tracker</h1>

    <div className="flex items-center gap-3">
      <button
        onClick={() => setShowAlerts((v) => !v)}
        className="relative bg-transparent border-0 cursor-pointer"
      >
        <img src={bellIcon} alt="Alerts" className="w-6 h-6 invert" />
      </button>

      <div className="relative">
          <input
            type="text"
            name="search"
            placeholder="Search Trip ID"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            className="py-[6px] pl-[8px] pr-[28px] w-[200px] rounded-[6px] border border-[#ddd] "
          />

          {term && (
            <button
              type="button"
              className="absolute top-0 bottom-0 right-2 flex items-center justify-center w-7 bg-transparent border-0 p-0 cursor-pointer"
              onClick={() => setTerm("")}
              aria-label="Clear search"
            >
              <img src={closeIcon} alt="" />
            </button>
          )}
        </div>
    </div>

    {showAlerts && <AlertsPanel onClose={() => setShowAlerts(false)} />}
  </header>

      <div className="p-4 flex gap-4">
        <div className="w-[70%] flex flex-col">
          {/* <WorldMap /> */}
          <WorldMap highlightId={highlightId || selectedTrip} />

        </div>

        <div className="w-[30%] flex flex-col">
          <div className="flex flex-col">
            <Controls />
            <TimeBar />
          </div>
          <div className="max-[750px]:hidden">
 <FleetSummary />
          </div>
         
        </div>
      </div>

      {/* <TripOverview highlightId={highlightId} /> */}
      <TripOverview highlightId={highlightId || selectedTrip} onSelect={setSelectedTrip} />

    </div>
  );
}


